import { IDoorInstallationModel, DoorInstallationModel } from './door-installation-model';

export interface IInstallationSiteModel {
    name: string;
    thumbnailUrl: string;
    isExcluded: boolean;
    doorInstallations: IDoorInstallationModel[];
}


export class InstallationSiteModel implements IInstallationSiteModel {
    public name: string = '';
    public thumbnailUrl: string = '';
    public isExcluded: boolean = false;
    public doorInstallations: IDoorInstallationModel[] = [];
}


